import * as React from "react";
import cctLogo from "../assets/cct-logo.png";
import { Link } from 'react-router-dom';

export default class Home extends React.PureComponent<{}, {}> {
  public render() {
    return (
      <section className="bg-grey-light min-h-screen flex flex-auto items-center justify-center home relative font-montserrat">
        {/* Logo */}
        <header className="block absolute pin-t pin-l p-4">
          <img
            src={cctLogo}
            alt="My Council Story"
            className="cct-logo"
          />
        </header>
        {/* Center Widget */}
        <div className="md:max-w-md sm:max-w-sm m-8 text-center">
          <h1 className="text-cct-blue font-bold font-montserrat text-center">
            My Council Story
          </h1>
          <p className="text-center my-5 font-montserrat">
            View Queensland through a kaleidoscope. <i>My Council Story</i> is an interactive tool allowing you to delve deeper into your council – and the neighbouring councils which make up our State.
          </p>
          <p className="text-center my-5 font-montserrat">
            Entirely voluntary and built on principles of open data, Queensland councils power the platform with information related to their role as leaders of communities across the state.
          </p>
          <p className="text-center my-5 font-montserrat">
            Get started and search for your council, selecting councils of similar size and capacity to compare.
          </p>
          <p className="text-center my-5 font-montserrat">
            Better councils make better communities.
          </p>
          <Link to="select" className="cta">
          Get Started
          </Link>
        </div>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/HomeScreen.tsx